// extracted by mini-css-extract-plugin
module.exports = {"Controls":"HistoryDomain_Controls__2OLUw","List":"HistoryDomain_List__1reT-"};